import React, { useState } from 'react';
import { Form, Button, Modal, Row, Col, FloatingLabel, Alert, Badge } from 'react-bootstrap';
import { BsCalendar, BsClock, BsPeople, BsMic, BsLink45Deg, BsXLg } from 'react-icons/bs';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const MeetingForm = () => {
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: null,
    startTime: null,
    endTime: null,
    meetingType: 'video',
    participants: [],
    newParticipant: '',
    recurring: false,
    recurrencePattern: 'none',
    agendaItems: [''],
  });

  const handleClose = () => {
    setShow(false);
    setValidated(false);
    setFormData({
      title: '',
      description: '',
      date: null,
      startTime: null,
      endTime: null,
      meetingType: 'video',
      participants: [],
      newParticipant: '',
      recurring: false,
      recurrencePattern: 'none',
      agendaItems: [''],
    });
  };

  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      // Submit logic here
      console.log('Meeting scheduled:', formData);
      handleClose();
    }
    setValidated(true);
  };

  const addAgendaItem = () => {
    setFormData(prev => ({
      ...prev,
      agendaItems: [...prev.agendaItems, '']
    }));
  };

  const removeAgendaItem = (index) => {
    setFormData(prev => ({
      ...prev,
      agendaItems: prev.agendaItems.filter((_, i) => i !== index)
    }));
  };

  const updateAgendaItem = (index, value) => {
    const newAgendaItems = [...formData.agendaItems];
    newAgendaItems[index] = value;
    setFormData(prev => ({
      ...prev,
      agendaItems: newAgendaItems
    }));
  };

  const addParticipant = () => {
    if (formData.newParticipant.trim()) {
      setFormData(prev => ({
        ...prev,
        participants: [...prev.participants, prev.newParticipant.trim()],
        newParticipant: ''
      }));
    }
  };

  const removeParticipant = (index) => {
    setFormData(prev => ({
      ...prev,
      participants: prev.participants.filter((_, i) => i !== index)
    }));
  };

  function submitButton(event){
      event.preventDefault();
      console.log(formData);
  }

  return (
    <>
      <Button variant="primary" onClick={handleShow} className="mb-4 btn btn-sm">
        <BsCalendar className="me-2" />
        <i className="bi bi-plus-lg d-none d-md-inline me-2"></i>
         Schedule  Meeting
      </Button>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Schedule New Meeting</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="mb-3">
              <Col md={8}>
                <FloatingLabel controlId="title" label="Meeting Title" className="mb-3">
                  <Form.Control
                    required
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Enter meeting title"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a meeting title.
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
              <Col md={4}>
                <FloatingLabel controlId="meetingType" label="Meeting Type">
                  <Form.Select
                    name="meetingType"
                    value={formData.meetingType}
                    onChange={handleChange}
                  >
                    <option value="video">Video Call</option>
                    <option value="audio">Audio Call</option>
                    <option value="in-person">In Person</option>
                    <option value="hybrid">Hybrid</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>

            <FloatingLabel controlId="description" label="Description" className="mb-3">
              <Form.Control
                as="textarea"
                name="description"
                value={formData.description}
                onChange={handleChange}
                style={{ height: '100px' }}
                placeholder="Enter meeting description"
              />
            </FloatingLabel>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="date">
                  <Form.Label><BsCalendar className="me-2" />Date</Form.Label>
                  <DatePicker
                    selected={formData.date}
                    onChange={(date) => setFormData(prev => ({ ...prev, date }))}
                    minDate={new Date()}
                    className="form-control"
                    required
                    placeholderText="Select date"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="startTime">
                  <Form.Label><BsClock className="me-2" />Start Time</Form.Label>
                  <TimePicker
  onChange={(time) => setFormData(prev => ({ ...prev, startTime: time }))}
  value={formData.startTime}
  disableClock={true}
  clearIcon={null}
  className="form-control"
/>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="endTime">
                  <Form.Label><BsClock className="me-2" />End Time</Form.Label>
            

                  <TimePicker
  onChange={(time) => setFormData(prev => ({ ...prev, startTime: time }))}
  value={formData.startTime}
  disableClock={true}
  clearIcon={null}
  className="form-control"
/>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label><BsPeople className="me-2" />Participants</Form.Label>
              <div className="d-flex mb-2">
                <Form.Control
                  type="email"
                  value={formData.newParticipant}
                  onChange={(e) => setFormData(prev => ({ ...prev, newParticipant: e.target.value }))}
                  placeholder="Add participant email"
                />
                <Button variant="outline-primary" onClick={addParticipant} className="ms-2">
                  Add
                </Button>
              </div>
              {formData.participants.length > 0 && (
                <div className="participant-tags">
                  {formData.participants.map((email, index) => (
                    <Badge key={index} bg="light" text="dark" className="me-2 mb-2 d-inline-flex align-items-center">
                      {email}
                      <Button variant="link" size="sm" className="p-0 ms-1" onClick={() => removeParticipant(index)}>
                        <BsXLg size={12} />
                      </Button>
                    </Badge>
                  ))}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Form.Label>Meeting Agenda</Form.Label>
                <Button variant="link" size="sm" onClick={addAgendaItem}>
                  + Add Item
                </Button>
              </div>
              {formData.agendaItems.map((item, index) => (
                <div key={index} className="d-flex align-items-center mb-2">
                  <Form.Control
                    type="text"
                    value={item}
                    onChange={(e) => updateAgendaItem(index, e.target.value)}
                    placeholder={`Agenda item ${index + 1}`}
                  />
                  {formData.agendaItems.length > 1 && (
                    <Button variant="link" className="text-danger ms-2" onClick={() => removeAgendaItem(index)}>
                      <BsXLg />
                    </Button>
                  )}
                </div>
              ))}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="switch"
                id="recurringSwitch"
                label="Recurring Meeting"
                name="recurring"
                checked={formData.recurring}
                onChange={handleChange}
              />
              {formData.recurring && (
                <div className="mt-2">
                  <Form.Select
                    name="recurrencePattern"
                    value={formData.recurrencePattern}
                    onChange={handleChange}
                  >
                    <option value="none">Select recurrence pattern</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="biweekly">Bi-weekly</option>
                    <option value="monthly">Monthly</option>
                  </Form.Select>
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label><BsLink45Deg className="me-2" />Meeting Link (auto-generated after creation)</Form.Label>
              <Form.Control type="text" placeholder="https://meet.example.com/abc123" disabled />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Schedule Meeting
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      
    </>
  );
};

export default MeetingForm;